// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"style_snackbar__bhu_m","safari":"style_safari__iywtV","container":"style_container__qqF8H","close":"style_close__znM22","error":"style_error__iQ7_R"};